<template>
  <div id="app" :class="scrollLock">
    <div class="webBg" :style="webBg"></div>
    <div class="container" :style="mobileBg">
      <img class="logo" src="./assets/image/logo.png" />
      <router-view />
      <div class="dialog-mask" v-if="dialog.opened"></div>
    </div>
  </div>
</template>
<script>
import { getRecaptchaScript, getEventConfig } from './utils/api';
import { mapGetters } from 'vuex';
export default {
  name: 'app',
  data() {
    return {
      webBg: {
        background: ''
      },
      type: '',
      mobileBg: {
        backgroundImage: '',
        backgroundColor: ''
      }
    };
  },
  mounted() {
    this.recaptchaScript();
    this.setBackground();
    window.addEventListener('resize', this.setViewHeight);
  },
  computed: {
    ...mapGetters(['dialog']),
    scrollLock() {
      return { scrollLock: this.dialog.opened };
    }
  },
  methods: {
    async recaptchaScript() {
      await getRecaptchaScript().then(res => {
        /*let parser = new DOMParser();
        let doc = parser.parseFromString(res, 'text/html');
        /!*document.head.prepend(doc.head.firstChild);*!/
        document.head.prepend(doc.head.lastChild);

        let s2 = document.createElement('script');
        s2.innerHTML = document.getElementsByTagName('script')[0].innerHTML;
        document.head.prepend(s2);

        let s = document.createElement('script');
        s.setAttribute('src', doc.head.firstChild.src);
        document.head.prepend(s);*/

        let d = document.createRange().createContextualFragment(res);
        document.head.appendChild(d);
      });

      let key = window.getGoogleRecaptchaKey();
      sessionStorage.setItem('recaptchaKey', key);
    },
    setViewHeight() {
      document.addEventListener('touchstart', function() {}, false);
      document.documentElement.style.setProperty(
        '--vh',
        window.innerHeight + 'px'
      );
      this.setBackground();
    },
    async setBackground() {
      await getEventConfig().then(res => {
        this.type = res?.app_display_template ?? 'PRAYING_CASH';
      });
      switch (this.type) {
        case 'CHINESE_VALENTINES':
          document.documentElement.style.setProperty(
            '--color-primary',
            'rgb(230, 59, 121)'
          );
          document.documentElement.style.setProperty(
            '--input-shadow',
            '5px 9px 20px rgba(101,50,107,0.45)'
          );
          document.documentElement.style.setProperty(
            '--input-text-shadow',
            '5px 8px 9px rgba(101,50,107,0.45)'
          );
          document.documentElement.style.setProperty(
            '--color-gold',
            'rgb(255,239,163)'
          );
          document.documentElement.style.setProperty(
            '--check-image',
            `url(${require('./assets/image/checkedCVday.png')})`
          );
          this.webBg.background =
            'linear-gradient(#936BB0 0%, #F494C2 65%, #FC5992 100%)';
          this.mobileBg.background =
            'linear-gradient(#936BB0 0%, #BE7DB8 30%, #9977B3 50%, #C38AC0 77%,#936BB0 100%)';
          break;
        case 'RED_ENVELOPES':
        case 'PRAYING_CASH':
          document.documentElement.style.setProperty(
            '--color-primary',
            'rgb(183,38,38)'
          );
          document.documentElement.style.setProperty(
            '--input-shadow',
            '5px 9px 20px rgba(133,15,21,0.45)'
          );
          document.documentElement.style.setProperty(
            '--input-text-shadow',
            '3px 4px 0 rgb(127,3,10)'
          );
          document.documentElement.style.setProperty(
            '--color-gold',
            'rgb(255,210,29)'
          );
          document.documentElement.style.setProperty(
            '--check-image',
            `url(${require('./assets/image/check.png')})`
          );
          this.webBg.background = `url(${require('./assets/image/pcbg.jpg')})`;
          this.mobileBg.backgroundImage = `url(${require('./assets/image/background.png')})`;
          this.mobileBg.backgroundColor = '#ad2826';
          break;
      }
    }
  }
};
</script>
<style></style>
